export default __webpack_public_path__ + "static/media/david.9caea06a.jpg";